import { VERNACULAR_DEFAULT_MESSAGES } from "constants/vernacularConstants";


interface ValidationReturnType{ error: string, hasError: boolean, isLatinDetected?: boolean };

/**
 * validation function for name field
 * @param value of type string or null
 */
 export const validateName = (value: string|null, errors?: {required: string, invalid: string, invalidRetry: string, minChar: string, maxChar: string}) : ValidationReturnType => {
  let validRegExp = new RegExp("[a-zA-Z ]", "ig");
  let error = "";
  let hasError = false;
  let isLatinDetected = false;
  if (typeof value !== "string") {
    error = (errors && errors.required) || VERNACULAR_DEFAULT_MESSAGES.THIS_FIELD_IS_REQUIRED;
    hasError = true;
    return {
      error,
      hasError,
    };
  }
  const name: string = value.trim();
  if (!name) {
    error = (errors && errors.required) || VERNACULAR_DEFAULT_MESSAGES.THIS_FIELD_IS_REQUIRED;
    hasError = true;
  } else if (name.length < 3) {
    error = (errors && errors.minChar) || VERNACULAR_DEFAULT_MESSAGES.NAME_MIN_CHARS;
    hasError = true;
  } else if (name.length > 100) {
    error = (errors && errors.maxChar) || VERNACULAR_DEFAULT_MESSAGES.NAME_MAX_CHARS;
    hasError = true;
  } else if (name.replace(validRegExp, "")) {
    error = (errors && errors.invalidRetry) || VERNACULAR_DEFAULT_MESSAGES.NUMBERS_NOT_SUPPORTED;
    hasError = true;
    isLatinDetected = true;
  } else {
    error = "";
    hasError = false;
  }

  return {
    error,
    hasError,
    isLatinDetected,
  };
};
